const UserInvalid = () => {
  return ( 
    <span>User does not exist.</span>
  );
}
 
export default UserInvalid;